<!-- The Modal -->
<div id="myModal" class="modal">
  <!-- Modal content -->
  <div class="modal-content ">
    <span class="close" (click)="closePopUp()">&times;</span>
    <p class="success user-msg" >{{responseMessage}} </p>

<!--    <div class="booking-btn tocart col-md-5" *ngIf="globalService.showexploremore"> <a href="/billing"> Procced to Cart<i class="fa fa-angle-right" aria-hidden="true"></i> </a>-->
<!--      <a href="/travel"> Continue Shopping<i class="fa fa-angle-right" aria-hidden="true"></i> </a>-->
<!--    </div>-->
    <!--    <div class="booking-btn tocart col-md-5" *ngIf="globalService.showexploremore"></div>-->

  </div>
</div>
